import React, { useCallback, useEffect, useState } from 'react'
import { Box, TextField } from '@mui/material'
import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@mui/material/Modal'
import ExpressBuyModal from 'src/components/BuyPolicy/insuranceScreens/bike/ExpressBuyModal'
import ExploreOptionsModal from 'src/components/BuyPolicy/insuranceScreens/bike/ExploreOptionsModal'
import { useDispatch, useSelector } from 'react-redux'
import { verifyMotorDetails } from 'src/services/buyPolicyMotorService'
import MotorDialog from 'src/components/BuyPolicy/insuranceScreens/motor/MotorDialog'
import {
  showNotificationMessage,
  updateIsVehiclePrefilledData,
  updateMotorDetails,
  updatePersonalDetailsMotor,
  updatePreviousPolicyDetailsMotor,
  updateTokenMotor,
  updateVehicleDetailsMotor,
} from 'src/actions'
import { getTokenForQrReport } from 'src/services/individualService'
import {
  formatLicensePlate,
  validateVehicleNumber,
} from 'src/utils/commonMethods/buyPolicy'
import { useHistory } from 'react-router-dom'
import {
  POLICY_TYPE_BIKE_EXPIRY,
  VEHICLE_TYPE,
  VEHICLE_TYPE_TEXT,
} from 'src/utils/constants/BuyPolicyBike'
import VehicleInformationModal from 'src/components/BuyPolicy/common/VehicleInformationModal'
import NoPreFilledData from 'src/components/BuyPolicy/insuranceScreens/motor/NoPrefilledDataModal'
import LoadingModal from 'src/components/common/LoadingModal'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { removeSpaces } from 'src/utils/commonMethods'
import { vehicleType } from 'src/utils/constants/BuyPolicyMotor'
import { CONTACT_FORM_ERROR_MESSAGES } from 'src/utils/constants/ValueAddedServicesData'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'
import { VEHICLE_DETAILS } from 'src/utils/constants/BuyPolicy'

const BikeDetails = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const [expressBuyModalOpen, setExpressBuyModalOpen] = useState(false)
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const vehicleDetail = motorDetails?.vehicleDetails
  const personalDetails = motorDetails?.personalDetails
  const previousPolicyDetails = motorDetails?.previousPolicyDetails
  const currentPolicyDetails = motorDetails?.currentPolicyDetails
  const [exploreOptionsModalOpen, setExploreOptionsModalOpen] = useState(false)
  const [vehicleDetails, setVehicleDetails] = useState({})
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false)
  const [showVehicalInformation, setShowVehicalInformation] = useState(false)

  const handleVehicleDetails = (e) => {
    setVehicleDetails({
      ...vehicleDetails,
      [e?.target?.name]: e?.target?.value,
    })
  }

  const handleOpenDialog = async () => {
    if (vehicleDetails?.vehicleNumber) {
      if (!validateVehicleNumber(vehicleDetails?.vehicleNumber)) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: CONTACT_FORM_ERROR_MESSAGES?.VALID_VEHICLE_NUMBER,
          })
        )
      } else {
        fetchToken()
      }
    } else {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: CONTACT_FORM_ERROR_MESSAGES?.VALID_VEHICLE_NUMBER,
        })
      )
    }
  }
  const fetchToken = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()

    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success

      setLoading(false)
      const token = response?.res?.data?.access_token
      dispatch(updateTokenMotor(token))
      getVehicleDetailsFromSingzy(token, vehicleDetails?.vehicleNumber)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: VEHICLE_DETAILS,
        })
      )
    }
  }
  const getVehicleDetailsFromSingzy = async (token, vehicleNumber) => {
    setLoading(true)
    try {
      const response = await verifyMotorDetails(token, vehicleNumber)

      if (response?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
        setIsErrorModalOpen(true)
      } else {
        // Success
        setLoading(false)
        const responseData = response?.data
        if (responseData?.success) {
          if (
            responseData.vehicleType === VEHICLE_TYPE?.FOUR_WHEELER ||
            responseData.vehicleType === VEHICLE_TYPE?.UNKNOWN
          ) {
            setShowVehicalInformation(true)
          } else {
            setOpen(true)
            dispatch(updateIsVehiclePrefilledData(true))
            const vehicleDetailsMotor = {
              ...vehicleDetail,
              chassisNumber: responseData?.chassis,
              engineNumber: responseData?.engine,
              vehicleNumber: formatLicensePlate(vehicleDetails.vehicleNumber),
              nickName: vehicleDetails.nickName,
              brand: {
                genericName: responseData?.vehicleManufacturerFirstName,
              },
              model: { modelGenericName: responseData?.model || '' },
              yearOfManufacturer: responseData?.manufacturingYear || '',
              monthOfManufacturer: responseData?.manufacturingMonth || '',
              regDate: responseData?.regDate,
              vehicleSubmit: true,
              fuelType: { genericName: responseData?.fuel },
              vehicleType: responseData?.vehicleType,
              vehicleLogo: responseData?.vehicleMakeLogo,
            }
            dispatch(updateVehicleDetailsMotor(vehicleDetailsMotor))

            const previousPolicyDetailsMotor = {
              ...motorDetails?.previousPolicyDetails,
              previousPolicyProvider: {
                insuranceCompanyName: responseData?.vehicleInsuranceCompanyName,
                insuranceCompanyFirstName:
                  responseData?.insuranceCompanyFirstName,
              },
              previousPolicyNumber: responseData?.vehicleInsurancePolicyNumber,
              isPolicyExpired: responseData?.vehicleInsuranceExpired
                ? POLICY_TYPE_BIKE_EXPIRY?.EXPIRED
                : POLICY_TYPE_BIKE_EXPIRY?.NOT_EXPIRED,
              expiryDate: !responseData?.vehicleInsuranceExpired
                ? responseData?.vehicleInsuranceUpto
                : '',
              expiredDate: responseData?.vehicleInsuranceExpired
                ? responseData?.vehicleInsuranceUpto
                : '',
              thirdPartyExpiryDate: '',
              thirdPartyProvider: '',
              thirdPartyPolicyNo: '',
              thirdPartyProviderFirstName: '',
            }

            dispatch(
              updatePreviousPolicyDetailsMotor(previousPolicyDetailsMotor)
            )
            dispatch(
              updatePersonalDetailsMotor({
                ...motorDetails?.personalDetails,
                pincode: responseData?.pincode,
                city: responseData?.city,
                state: responseData?.state,
                fullAddress: responseData?.address,
              })
            )
          }
        } else {
          setLoading(true)
          setIsErrorModalOpen(true)
          dispatch(
            showNotificationMessage({
              type: NOTIFICATION_TYPES?.ERROR,
              message: responseData?.message,
            })
          )
          dispatch(
            updateVehicleDetailsMotor({
              ...vehicleDetail,
              vehicleNumber: formatLicensePlate(vehicleDetails?.vehicleNumber),
            })
          )
          setLoading(false)
        }
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: VEHICLE_DETAILS,
        })
      )
    }
  }

  const handleSubmit = async (values, setSubmitting) => {
    setSubmitting(true)
    handleDispatches(values)
    handleClose()
    history.push('/individual/dashboard/buyPolicy/bike/insuranceDetails')
  }
  const handleDispatches = (values) => {
    dispatch(
      updateMotorDetails({
        vehicleDetails: {
          ...vehicleDetail,
          isCompany: values?.isCompany,
          companyName: values?.companyName,
        },
        personalDetails: {
          ...personalDetails,
          name: values?.name,
          mobileNumber: values?.mobileNumber,
          email: values?.email,
        },
        previousPolicyDetails: {
          ...previousPolicyDetails,
          previousPolicyProvider: {
            ...previousPolicyDetails?.previousPolicyProvider,
            insuranceCompanyName: values?.previousPolicyProvider,
            insuranceCompanyFirstName: values?.previousPolicyProviderFirstName,
          },
          previousPolicyNumber: values?.previousPolicyNumber,
          existingPolicyClaim: values?.existingPolicyClaim,
          ncb: values?.ncb,
          isPolicyExpired: values?.isPolicyExpired,
          expiryDate: values?.expiryDate,
          expiredDate: values?.expiredDate,
          isPolicyExpiredBeforeDate: values?.isPolicyExpiredBeforeDate,
          thirdPartyExpiryDate: values?.thirdPartyExpiryDate,
          thirdPartyPolicyNo: values?.thirdPartyPolicyNo,
          thirdPartyStartDate: values?.thirdPartyStartDate,
          thirdPartyProvider: values?.thirdPartyProvider,
          insuranceCompanyFirstName: values?.thirdPartyProviderFirstName,
        },
        currentPolicyDetails: {
          ...currentPolicyDetails,
          policyType: values?.policyType,
        },
      })
    )
  }
  const handleClose = () => {
    setOpen(false)
  }

  const handleFourWheeler = () => {
    history.push('/individual/dashboard/buyPolicy/motor')
  }
  const handlePrefillData = useCallback(() => {
    setVehicleDetails({
      vehicleNumber: removeSpaces(vehicleDetail?.vehicleNumber),
      nickName: vehicleDetail?.nickName,
    })
  }, [vehicleDetail])

  useEffect(() => {
    handlePrefillData()
    if (vehicleDetail?.regDate) {
      setOpen(true)
    }
  }, [handlePrefillData, vehicleDetail?.regDate])

  return (
    <Box>
      <LoadingModal loading={loading} />
      {isErrorModalOpen ? (
        <Modal
          open={isErrorModalOpen}
          onClose={() => setIsErrorModalOpen(false)}
          id='errorModal'
        >
          <div className={'modal-container'}>
            <NoPreFilledData
              handleClose={() => setIsErrorModalOpen(false)}
              number={vehicleDetails?.vehicleNumber}
              vehicleType={vehicleType?.TWO_WHEELER}
            />
          </div>
        </Modal>
      ) : null}

      {showVehicalInformation ? (
        <VehicleInformationModal
          open={showVehicalInformation}
          setOpen={setShowVehicalInformation}
          buyType={VEHICLE_TYPE_TEXT?.TWO_WHEELER}
          vehicleType={VEHICLE_TYPE_TEXT?.FOUR_WHEELER}
          handleClick={handleFourWheeler}
        />
      ) : null}
      <ExploreOptionsModal
        open={exploreOptionsModalOpen}
        setOpen={setExploreOptionsModalOpen}
        id='ExploreOptionsModal'
      />
      <ExpressBuyModal
        open={expressBuyModalOpen}
        setOpen={setExpressBuyModalOpen}
        id='ExpressBuyModal'
      />
      <Box className={classes.bikeDetailsContainer}>
        {open ? (
          <MotorDialog
            open={open}
            setOpen={setOpen}
            handleSubmit={handleSubmit}
          />
        ) : null}
        <Box className={classes.bikeDetailsSectionMain}>
          <Box className={classes.bikeDetailsSectionHeading}>
            Buy your two-wheeler insurance
          </Box>
          <Box>
            <TextField
              variant='standard'
              name='vehicleNumber'
              classes={`${classes.bikeDetailsSectionInput} ${classes.vehicleNumberField}`}
              value={vehicleDetails?.vehicleNumber}
              onChange={handleVehicleDetails}
              placeholder={'Enter bike number: (eg. UP-15-AB-1234)'}
              InputProps={{
                className: classes.bikeDetailsSectionInput,
                disableUnderline: true,
              }}
            />
          </Box>
          <Box className={classes.bikeBuyOptionsContainer}>
            {/* {Buttons as per figma} */}
            {/* <Button onClick={() => setExpressBuyModalOpen(true)} id='expressBuyButton'>
              <Box className={classes.expressBuyContainer}>
                <Box className={classes.expressBuyButtonContainer}>
                  <Box>
                    <img src={ExpressBuyImg} height={'34.16px'} width={'39.68'} alt='expressBuy' />
                  </Box>
                  <Box className={classes.expressBuyButtonContent}>
                    <Box className={classes.expressBuyButtonHeading}>Express Buy</Box>
                    <Box className={classes.expressBuyButtonTag}>in 1 min</Box>
                  </Box>
                </Box>
                <Box className={classes.thirdPartyText}>Third-party plans</Box>
              </Box>
            </Button>
            <Button onClick={() => setExploreOptionsModalOpen(true)} id='exploreOptionsButton'>
              <Box className={classes.exploreOptionsContainer}>
                <Box className={classes.exploreOptionsButtonContainer}>
                  <Box>
                    <img
                      src={ExploreOptionImg}
                      height={'34.16px'}
                      width={'39.68'}
                      alt='exploreOptions'
                    />
                  </Box>
                  <Box className={classes.exploreOptionsButtonContent}>
                    <Box className={classes.exploreOptionsButtonHeading}>Explore Options</Box>
                    <Box className={classes.exploreOptionsButtonTag}>if no rush</Box>
                  </Box>
                </Box>
                <Box className={classes.comprehensivePlanText}>OD & Comprehensive plans</Box>
              </Box>
            </Button> */}
            <Button
              variant='contained'
              onClick={handleOpenDialog}
              className={classes.secureBtn}
            >
              Secure
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default BikeDetails

const useStyles = makeStyles({
  bikeDetailsContainer: {
    background: 'linear-gradient(180deg, #DFF7FF 4.08%, #FFFFFF 102.47%)',
    backgroundSize: '100% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#FFFFFF',
  },
  bikeDetailsSectionMain: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    position: 'relative',
    zIndex: 2,
    width: '100%',
    gap: 20,
    paddingTop: 50,
  },
  bikeDetailsSectionHeading: {
    fontFamily: 'Roboto',
    fontSize: '21px',
    fontWeight: 400,
    lineHeight: '25px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: '#000000',
  },
  bikeDetailsSectionInput: {
    textTransform: 'capitalize',
    background: '#FFFFFF',
    boxShadow: '0px 4px 10px 0px #0000001A',
    width: '446px',
    height: '55px',
    border: '1px',
    borderRadius: '10px',
    padding: '0px 20px',
    '& input::placeholder': {
      fontFamily: 'Roboto',
      fontSize: '15px',
      fontStyle: 'italic',
      fontWeight: 400,
      lineHeight: '18px',
      letterSpacing: '0em',
      textAlign: 'center',
      color: '#8B8B8B',
    },
  },
  vehicleNumberField: {
    '& .MuiInputBase-input': {
      textTransform: 'uppercase !important',
    },
  },
  bikeBuyOptionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
  },
  expressBuyContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5,
  },
  exploreOptionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5,
  },
  expressBuyButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '215px',
    height: '67px',
    borderRadius: '10px',
    border: '1px solid #34C0E5',
    gap: 10,
  },
  exploreOptionsButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '215px',
    height: '67px',
    borderRadius: '10px',
    border: '1px solid #34C0E5',
    backgroundColor: '#34C0E5',
    gap: 10,
  },
  thirdPartyText: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontStyle: 'italic',
    fontWeight: 400,
    lineHeight: '15px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: '#575757',
  },
  comprehensivePlanText: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontStyle: 'italic',
    fontWeight: 400,
    lineHeight: '15px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: '#575757',
  },
  expressBuyButtonContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  exploreOptionsButtonContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  expressBuyButtonHeading: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontStyle: 'italic',
    fontWeight: 500,
    lineHeight: '19px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: '#34C0E5',
  },
  expressBuyButtonTag: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'italic',
    fontWeight: 500,
    lineHeight: '14px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: '#616161',
  },
  exploreOptionsButtonHeading: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '19px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: '#FFFFFF',
  },
  exploreOptionsButtonTag: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '14px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: '#000000',
  },
  bikeDetailsInputPlaceHolder: {
    fontFamily: 'Roboto',
    fontSize: '15px',
    fontStyle: 'italic',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: '#8B8B8B',
  },
  secureBtn: {
    background: 'linear-gradient(180deg, #4DC3E3 0%, #1EA0C4 100%)',
    height: '30px',
    fontSize: '12px',
    padding: '17px 30px 15px 30px',
    color: '#FFFFFF',
  },
})
